interface IErrField {
  [key: string]: string[];
}

export const formValidateByRes = (
  err: any,
  setError: (fieldName: any, options: object) => void,
): string[] | undefined => {
  if (err?.status === 400) {
    const errorsArray = err?.data;

    if (Array.isArray(errorsArray) && errorsArray.length) {
      let errorFields: string[] = [];
      errorsArray.forEach((field: IErrField, i) => {
        if (typeof field === 'object') {
          Object.keys(field).forEach((fieldKey) => {
            errorFields.push(fieldKey);
            if (setError) {
              setError(fieldKey, { message: errorsArray[i][fieldKey]?.[0] });
            }
          });
        }
      });
      return errorFields.length ? errorFields : undefined;
    }
  }
};

export const formValidationIsUserYoung = (errorsFields: string[] | undefined): boolean | undefined => {
  if (Array.isArray(errorsFields)) {
    const responsibleFields = errorsFields.filter((f) => f.match(/responsible/));
    return errorsFields.length === responsibleFields.length;
  }
};
